import type { ReactNode } from 'react';
import SharePreviewDownloadButton from 'components/ShareDocument/SharePreviewContent/SharePreviewDownloadButton';

interface SharePreviewToolbarProps {
  url: string;
  filename?: string;
  /** 'plain' shows only the download button; 'grid' adds the left/right slots (PDF). */
  variant?: 'plain' | 'grid';
  left?: ReactNode;
  right?: ReactNode;
}

const SharePreviewToolbar = ({ url, filename, variant = 'plain', left, right }: SharePreviewToolbarProps) => (
  <div
    className={`px-3 py-2 rounded-top bg-grey share-preview-controls ${
      variant === 'grid' ? 'share-preview-controls-grid border-bottom' : ' d-flex justify-content-end'
    }`}
  >
    {variant === 'grid' && <div className='share-preview-controls-zoom'>{left}</div>}
    {variant === 'grid' && <div className='share-preview-controls-pagination'>{right}</div>}
    <SharePreviewDownloadButton url={url} filename={filename} />
  </div>
);

export default SharePreviewToolbar;
